// extracted by mini-css-extract-plugin
export default {"title":"Title_title__7-y6R","titleHasCaps":"Title_titleHasCaps__8qnI1"};